import { HttpInterceptorFn } from '@angular/common/http';
import { CROSS_ORIGIN_XSRF_CONFIG } from './xsrf.config';
import { inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { resolveXsrfHeader } from './xsrf.util';

export const crossOriginXsrfInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(CROSS_ORIGIN_XSRF_CONFIG);
  const location = inject(PlatformLocation);

  const result = resolveXsrfHeader(req.url, req.method, config, location.href);

  if (result.kind === 'skip') {
    return next(req);
  }

  let headers = req.headers;

  if (result.kind === 'apply' && !req.headers.has(result.headerName)) {
    headers = headers.set(result.headerName, result.token);
  }

  return next(
    req.clone({
      withCredentials: true,
      headers,
    }),
  );
};
